import styled from 'styled-components';

export const BtnContainer = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  min-width: 115px;
  width: fit-content;
  background-color: #f1e6fc;
  border: 1px solid #c596f2;
  border-radius: 23px;
  padding: 6px, 8px, 6px, 6px;
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #8a2be5;
  cursor: pointer;
`;
